/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Allowed_Ranks_HintInputs */



/**
* | output |
* | --- |
* | "Nothing selected = no rank restriction." |
*
* @param {Promo_Allowed_Ranks_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_allowed_ranks_hint = /** @type {((inputs?: Promo_Allowed_Ranks_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Allowed_Ranks_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien sélectionné = aucune restriction de rang.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nada seleccionado = sin restricción de rango.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nada selecionado = sem restrição de categoria.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna selezione = nessuna restrizione di rank.")
	return /** @type {LocalizedString} */ ("Nothing selected = no rank restriction.")
});